<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="parkingLotIdSearch">
        <el-select
          v-model="parkingLotId"
          filterable
          @change="parkingLotQueryChanged"
          style="width: 100%"
          placeholder="车场名称"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="shopIdSearch">
        <el-select v-model="shopId" filterable style="width: 100%" placeholder="商家名称">
          <el-option
            v-for="item in shopList"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="balanceTimeRangeSearch">
        <el-date-picker
          v-model="balanceTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </template>
      <template
        slot-scope="scope"
        slot="totalCouponDiscountAmountSearch"
        id="totalCouponDiscountAmount"
      >
        <el-input v-model="totalCouponDiscountAmount" disabled="true" placeholder="0"></el-input>
      </template>
      <template
        slot-scope="scope"
        slot="totalBalanceDiscountAmountSearch"
        id="totalBalanceDiscountAmount"
      >
        <el-input v-model="totalBalanceDiscountAmount" disabled="true" placeholder="0"></el-input>
      </template>
      <template slot-scope="scope" slot="totalBalancePayAmountSearch" id="totalBalancePayAmount">
        <el-input v-model="totalBalancePayAmount" disabled="true" placeholder="0"></el-input>
      </template>

      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permissionList.balanceBtn"
          @click="beforeOpen"
          >结算
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      id="coupon_balance_form"
      title="结算"
      :visible.sync="showCouponBalanceDialog"
      :modal-append-to-body="false"
      width="40%"
      @close="closeDialog"
    >
      <el-row v-if="showCouponBalanceDialog">
        <el-form ref="balanceForm" :model="balanceForm" label-width="100px" margin-top="0">
          <el-col span="12">
            <el-form-item
              label="车场名称"
              prop="parkingLotId"
              :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' }]"
            >
              <el-select
                v-model="balanceForm.parkingLotId"
                style="width: 100%"
                placeholder="车场名称"
                disabled="true"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="商家名称"
              prop="shopId"
              :rules="[{ required: true, message: '请选择商家名称', trigger: 'change' }]"
            >
              <el-select
                v-model="balanceForm.shopId"
                style="width: 100%"
                placeholder="商家名称"
                @change="chopChanged"
              >
                <el-option
                  v-for="item in shopListNotDeleted"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item
              label="开始时间"
              prop="balanceStartTime"
              :rules="[{ required: true, message: '请选择开始时间', trigger: 'change' }]"
            >
              <el-date-picker
                v-model="balanceForm.balanceStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="开始时间"
                style="width: 100%"
                disabled="true"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="结束时间"
              prop="balanceEndTime"
              ref="balanceEndTime"
              :rules="endTimeRules"
            >
              <el-date-picker
                v-model="balanceForm.balanceEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="结束时间"
                style="width: 100%"
                @change="endTimeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠金额"
              prop="couponDiscountAmount"
              :rules="[{ required: true, message: '优惠金额', trigger: 'change' }]"
            >
              <el-input v-model="balanceForm.couponDiscountAmount" disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="减免金额" prop="balanceDiscountAmount" :rules="discountRules">
              <el-input v-model="balanceForm.balanceDiscountAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="结算金额"
              prop="balancePayAmount"
              :rules="[{ required: true, message: '结算金额', trigger: 'change' }]"
            >
              <el-input v-model="balanceForm.balancePayAmount" disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="结算方式"
              prop="balanceType"
              :rules="[{ required: true, message: '请选择结算方式', trigger: 'change' }]"
            >
              <el-select
                v-model="balanceForm.balanceType"
                style="width: 100%"
                placeholder="结算方式"
              >
                <el-option
                  v-for="item in balanceTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                maxlength="200"
                multiline="true"
                v-model="balanceForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col offset="9" id="button-back">
            <el-button
              type="primary"
              icon="el-icon-circle-check"
              @click="saveData"
              :disabled="buttonDisabled"
              >保 存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="closeDialog" :disabled="buttonDisabled"
              >返回</el-button
            >
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getCouponAmount,
  lastEndTime,
} from '@/api/v4ward/park/couponv2/balance/carcouponbalanceaccounts';
import { getDiscountAmount } from '@/api/v4ward/park/couponv2/used/carcouponused';
import { shopList } from '@/api/v4ward/park/couponv2/shop/carcouponshop';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { getDictionary } from '@/api/common';
import func from '@/util/func';
import { mapGetters } from 'vuex';

export default {
  data() {
    var moneyCheck = (rule, value, callback) => {
      if ((typeof value !== 'number' && isNaN(value)) || value < 0) {
        callback(new Error('请输入有效金额!'));
      } else if (value > this.balanceForm.couponDiscountAmount) {
        callback(new Error('减免金额不能超过优惠金额!'));
      } else {
        var stringValue = value + '';
        var valueArray = stringValue.split('.');
        if (
          stringValue.startsWith('0') &&
          !stringValue.startsWith('0.') &&
          stringValue.length > 1
        ) {
          callback(new Error('请输入有效金额!'));
        } else if (valueArray.length === 2 && valueArray[1].length > 2) {
          callback(new Error('最多2位有效数字!'));
        } else {
          this.balanceForm.balancePayAmount = this.balanceForm.couponDiscountAmount - value;
          callback();
        }
      }
    };
    var checkEndTime = (rule, value, callback) => {
      var dateNow = new Date();
      var selectedTime = new Date(value);
      var startTime = new Date(this.balanceForm.balanceStartTime);
      if (dateNow.getTime() < selectedTime.getTime()) {
        callback(new Error('结束时间必须小于当前时间！'));
      }
      if (selectedTime.getTime() <= startTime.getTime()) {
        callback(new Error('结束时间必须大于开始时间！'));
      } else {
        callback();
      }
    };
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: true,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        columnBtn: true,
        refreshBtn: true,
        emptyBtn: true,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            search: true,
            searchSpan: 6,
            searchslot: true,
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopId',
            hide: true,
            type: 'select',
            display: false,
            searchSpan: 6,
            search: true,
            showColumn: false,
            searchslot: true,
            rules: [
              {
                required: true,
                message: '请输入结算商家id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopName',
            rules: [
              {
                required: true,
                message: '请输入商家名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结算周期',
            prop: 'balanceCycle',
            width: 150,
            rules: [
              {
                required: true,
                message: '请输入结算周期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠金额',
            prop: 'couponDiscountAmount',
            rules: [
              {
                required: true,
                message: '请输入优惠券优惠总金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '减免金额',
            prop: 'balanceDiscountAmount',
            rules: [
              {
                required: true,
                message: '请输入结算优惠金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结算金额',
            prop: 'balancePayAmount',
            rules: [
              {
                required: true,
                message: '请输入结算付款金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结算时间',
            prop: 'balanceTimeRange',
            hide: true,
            display: false,
            search: true,
            searchSpan: 12,
            searchslot: true,
            showColumn: false,
          },
          {
            label: '结算时间',
            prop: 'balanceTime',
            width: 160,
            rules: [
              {
                required: true,
                message: '请输入结算付款金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠金额',
            prop: 'totalCouponDiscountAmount',
            search: true,
            searchslot: true,
            searchSpan: 6,
            showColumn: false,
            hide: true,
            display: false,
          },
          {
            label: '减免金额',
            prop: 'totalBalanceDiscountAmount',
            search: true,
            searchslot: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            display: false,
          },
          {
            label: '结算金额',
            prop: 'totalBalancePayAmount',
            search: true,
            searchslot: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            display: false,
          },
          {
            label: '结算方式',
            prop: 'balanceType',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=coupon_balance_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择结算方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
            width: 180,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
      spaceList: [],
      parkingLotId: '',
      temParkingLotId: '',
      shopId: '',
      temShopId: '',
      firstDisplayFlag: true,
      balanceTimeRange: [],
      totalBalancePayAmount: 0,
      totalBalanceDiscountAmount: 0,
      totalCouponDiscountAmount: 0,
      showCouponBalanceDialog: false,
      balanceTypeList: [],
      shopList: [],
      shopListNotDeleted: [],
      buttonDisabled: false,
      balanceForm: {
        parkingLotId: '',
        shopId: '',
        balanceStartTime: '',
        balanceEndTime: '',
        couponDiscountAmount: 0,
        balancePayAmount: 0,
        balanceDiscountAmount: 0,
        balanceType: '',
      },
      endTimeRules: [
        { required: true, message: '请选择结束时间', trigger: 'change' },
        { validator: checkEndTime, trigger: 'blur' },
      ],
      discountRules: [
        { required: true, message: '请输入减免金额', trigger: 'blur' },
        { validator: moneyCheck, trigger: 'blur' },
      ],
    };
  },
  created() {
    this.initTimeRange();
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        // 默认查询第一个
        this.parkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
        this.initShopList(this.spaceList[0].id);
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
    });

    getDictionary('coupon_balance_type').then((data) => {
      this.balanceTypeList = data.data;
      if (this.balanceTypeList.length > 0) {
        this.balanceForm.balanceType = this.balanceTypeList[0].dictKey;
      }
    });
    this.$nextTick(() => {
      setTimeout(() => {
        console.log(this.$refs.crud.$children[1]);
        this.$refs.crud.$children[1].$children[5].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 370) {
            this.option.height = this.bodyHeight - 280;
          } else {
            this.option.height = this.bodyHeight - 370;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.height = this.bodyHeight - 370;
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        balanceBtn: this.vaildData(this.permission.carcouponbalanceaccounts_balance, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    endTimeChanged(value) {
      var checkRessult = true;
      this.$refs.balanceForm.validateField(['balanceEndTime', 'shopId'], (valid) => {
        checkRessult = checkRessult && this.vdui.isEmpty(valid);
      });
      if (checkRessult) {
        var param = {
          parkingLotId: this.balanceForm.parkingLotId,
          shopId: this.balanceForm.shopId,
          useTimeRange: this.balanceForm.balanceStartTime + ',' + this.balanceForm.balanceEndTime,
        };
        getDiscountAmount(param).then(({ data }) => {
          this.balanceForm.couponDiscountAmount = data;
          this.balanceForm.balancePayAmount = data;
        });
      }
    },
    initTimeRange() {
      var startTime = func.getCurrentMonthFirst() + ' 00:00:00';
      var endTime = func.getCurrentMonthLast() + ' 23:59:59';
      this.balanceTimeRange = [startTime, endTime];
    },
    initShopList(parkingLotId) {
      shopList({ parkingLotId: parkingLotId }).then((data) => {
        this.shopList = data.data;
        this.shopListNotDeleted = this.shopList.filter((shop) => {
          return shop.status > 0;
        });
        if (this.shopList.length > 0) {
          var shopColumn = this.findObject(this.option.column, 'shopId');
          //shopColumn.searchValue = this.shopList[0].id;
          this.shopId = this.shopList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.shopId = '';
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    chopChanged(shopId) {
      this.initBalanceStartTime(shopId);
    },
    closeDialog() {
      this.showCouponBalanceDialog = false;
      this.buttonDisabled = false;
    },
    saveData() {
      this.buttonDisabled = true;
      this.$refs.balanceForm.validate((valid) => {
        if (valid) {
          this.balanceForm.balanceCycle =
            this.balanceForm.balanceStartTime.substring(0, 10) +
            '~' +
            this.balanceForm.balanceEndTime.substring(0, 10);
          add(this.balanceForm).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.showCouponBalanceDialog = false;
            },
            (error) => {
              window.console.log(error);
              this.buttonDisabled = false;
            }
          );
        } else {
          this.buttonDisabled = false;
        }
      });
    },
    parkingLotQueryChanged(value) {
      if (this.vdui.isNotEmpty(value)) {
        this.initShopList(value);
      }
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen() {
      this.balanceForm = {
        parkingLotId: '',
        shopId: '',
        balanceStartTime: '',
        balanceEndTime: '',
        couponDiscountAmount: 0,
        balancePayAmount: 0,
        balanceDiscountAmount: 0,
        balanceType: '',
      };
      this.buttonDisabled = false;
      if (this.balanceTypeList.length > 0) {
        this.balanceForm.balanceType = this.balanceTypeList[0].dictKey;
      }
      this.showCouponBalanceDialog = true;
      this.balanceForm.parkingLotId = this.parkingLotId;
      if (this.shopListNotDeleted.length > 0) {
        this.balanceForm.shopId = this.shopList[0].id;
        this.balanceForm.shopName = this.shopList[0].shopName;
        this.initBalanceStartTime(this.balanceForm.shopId);
      }
    },
    initBalanceStartTime(shopId) {
      lastEndTime({ shopId: shopId }).then(({ data }) => {
        this.balanceForm.balanceStartTime = data;
      });
      this.balanceForm.balanceEndTime = '';
    },
    searchReset() {
      this.query = {
        // shopId:this.temShopId,
        // parkingLotId:this.temParkingLotId,
      };
      this.parkingLotId = this.temParkingLotId;
      this.initTimeRange();
      this.initShopList(this.temParkingLotId);
      // this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      this.loading = false;
      page = page || this.page;
      this.query.parkingLotId = this.parkingLotId;
      if (this.vdui.isEmpty(this.query.parkingLotId)) {
        return;
      }
      this.loading = true;
      if (this.vdui.isNotEmpty(this.shopId)) {
        this.query.shopId = this.shopId;
      }
      if (this.balanceTimeRange) {
        this.query.balanceTimeRange = this.balanceTimeRange[0] + ',' + this.balanceTimeRange[1];
      }
      this.temParkingLotId = this.query.parkingLotId;
      this.temShopId = this.query.shopId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            this.firstDisplayFlag = false;
          }
        }
      );

      getCouponAmount(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          this.query
        )
      ).then(({ data }) => {
        this.totalCouponDiscountAmount = data.couponDiscountAmount;
        this.totalBalanceDiscountAmount = data.balanceDiscountAmount;
        this.totalBalancePayAmount = data.balancePayAmount;
      });
    },
  },
};
</script>

<style>
#coupon_balance_form .el-dialog__body {
  padding-right: 60px;
}

#button-back .el-button + .el-button {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}

#button-back .el-button--small {
  padding: 9px 20px;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
